import ReturnFormPage from '@moncler/components/clientService/ReturnFormPage';
import { configureAccountStore } from '@state';
import React from 'react';
import { Provider } from 'react-redux';
const store = configureAccountStore();
const ReturnFormPageLoader = (props) => {
    return (React.createElement(Provider, { store: store },
        React.createElement(ReturnFormPage, Object.assign({}, props))));
};
export default ReturnFormPageLoader;
